"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EHabilitationTrads = void 0;
exports.EHabilitationTrads = {
    carte_t: "Carte T",
    CIF: "CIF",
    courtier_en_assurance: "Courtier en assurance",
    demarchage_bancaire_et_financier: "Démarchage bancaire et financier",
    IOBSP: "IOBSP",
    PSI: "PSI",
};
